import { BASE_PATHS } from './const';
import { ProductConfigurationModule } from './type';

export const getProductDetails = (
  path: string,
): {
  productId: string; basePath: string;
} => {
  const productDetails = Object.entries(BASE_PATHS)
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    .find(([_productId, productPath]) => path.startsWith(productPath));

  return productDetails
    ? { productId: productDetails[0], basePath: productDetails[1] }
    : { productId: '', basePath: '' };
};

export const loadProductConfiguration = (productId: string): Promise<ProductConfigurationModule> => (
  import(`../products/${productId}/product.config`)
);
